/**
 * Backend may expose the 1–100 % value under different JSON keys.
 */
export function getOfferDiscountPercent(offer) {
    if (!offer) return null
    const raw =
        offer.discount ??
        offer.discountPercent ??
        offer.discountPercentage ??
        offer.percentDiscount ??
        offer.discountPct
    if (raw === '' || raw === undefined || raw === null) return null
    const n = Number(raw)
    return Number.isFinite(n) ? n : null
}

/**
 * Human-readable establishment name when the offer DTO includes it.
 */
export function getOfferMechanicName(offer) {
    if (!offer) return null
    const raw =
        offer.mechanicName ??
        offer.establishmentName ??
        offer.mechanicEstablishmentName ??
        offer.establishmentTradeName ??
        offer.tradeName
    if (typeof raw !== 'string') return null
    const trimmed = raw.trim()
    return trimmed.length ? trimmed : null
}
